import React from 'react';
import { LiaLinkedinIn } from 'react-icons/lia';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="site-footer" style={footerStyle}>
      <div style={columnStyle}>
        <h4 style={columnHeading}>Kontakt</h4>
        <a href="mailto:cm@aice.dk" style={infoLink}>cm@aice.dk</a>
        <a href="tel:+4531450388" style={infoLink}>+45 31 45 03 88</a>
        <p style={infoText}>Olivia Hansens Gade 3, 2. sal, 1799 København V</p>
        <a
          href="https://www.linkedin.com/company/aice-agency/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ ...infoLink, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
        >
          <LiaLinkedinIn style={{ fontSize: '2.5rem' }} aria-label="LinkedIn" />
        </a>
      </div>

      <div style={{ ...columnStyle, justifyContent: 'flex-end', alignItems: 'center' }}>
        <p style={trademarkText}>© {currentYear} AICE Platform - CVR-45188205</p>
      </div>

      <div style={{ ...columnStyle, alignItems: 'flex-end' }}>
        <a
          href="https://meetings-eu1.hubspot.com/claus-moeldrup"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <button
            type="button"
            style={bookButton}
            onMouseOver={(e) => {
              e.target.style.background = 'none';
              e.target.style.color = '#C03626';
              e.target.style.border = '1px solid #C03626';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #C03626, #FF6F61)';
              e.target.style.color = '#fff';
              e.target.style.border = 'none';
            }}
          >
            Book et møde
          </button>
        </a>
      </div>
    </footer>
  );
};

export default Footer;

const footerStyle = {
  padding: '3rem clamp(1rem, 5vw, 5rem)',
  background: '#FFF1EE',
  borderTop: '1px solid #F3D3CB',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '2rem',
};

const columnStyle = {
  flex: '1 1 220px',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  color: '#31171A',
};

const columnHeading = {
  margin: 0,
  fontSize: '1.1rem',
  color: '#C03626',
};

const infoLink = {
  color: '#31171A',
  textDecoration: 'none',
  fontWeight: 500,
};

const infoText = {
  margin: 0,
  lineHeight: 1.4,
  fontWeight: 500,
};

const trademarkText = {
  margin: 0,
  fontWeight: 600,
  textAlign: 'center',
};

const bookButton = {
  marginTop: '0.5rem',
  background: 'linear-gradient(135deg, #C03626, #FF6F61)',
  color: '#fff',
  padding: '0.65rem 1.5rem',
  borderRadius: '8px',
  border: 'none',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  alignItems: 'center',
};
